import PropTypes from 'prop-types';
import React from 'react';
import { Mutation } from 'react-apollo';
import { FaTrash } from 'react-icons/fa';
import { Button } from 'reactstrap';
import { showConfirmation } from '../ConfirmationDialogService';
import { DELETE_MULTIPLE_SCAN_PROCEDURE_MAPPING } from '../queries';
import { displayError, displaySuccess, logAmplitudeEvent } from '../utilities';

const getMessage = () => (
  <>
    <span>
      Permanently delete the selected scans?
      <br />
      <strong>THIS PROCESS IS IRREVERSIBLE!</strong>
      <br />
      <small>ANY APP DEPEND ON THIS ACCOUNT WILL BECOME USELESS</small>
    </span>
  </>
);

const DeleteMultipleScanMapping = ({ scanNames, onDeleteCompleted }) => {
  const confirm = deleteMultipleScanMapping => {
    showConfirmation('Delete Scan Mapping?', getMessage(), () =>
      deleteMultipleScanMapping({ variables: { scanNames } })
    );
  };

  return (
    <Mutation
      mutation={DELETE_MULTIPLE_SCAN_PROCEDURE_MAPPING}
      onCompleted={() => {
        displaySuccess(`${scanNames.length} scans deleted`);
        logAmplitudeEvent(
          'Scan_procedure_mappings_deleted',
          { deletedScanNames: scanNames.join(', ') },
          true
        );
        onDeleteCompleted();
      }}
      onError={e => {
        displayError(e);
        onDeleteCompleted();
      }}
      refetchQueries={() => ['GET_SCAN_PROCEDURE_MAPPING']}
    >
      {(deleteMultipleScanMapping, { loading }) => {
        return (
          <Button
            disabled={loading}
            color="link"
            onClick={() => confirm(deleteMultipleScanMapping)}
          >
            <FaTrash />
          </Button>
        );
      }}
    </Mutation>
  );
};

DeleteMultipleScanMapping.propTypes = {
  scanNames: PropTypes.arrayOf(PropTypes.string),
  onDeleteCompleted: PropTypes.func.isRequired
};

export default DeleteMultipleScanMapping;
